// src/pages/Disclaimer.jsx
import React from "react";
import "../styles/disclaimer.css";

const Disclaimer = () => {
  return (
    <div className="disclaimer-container">
      <h1>Disclaimer</h1>
      <p>
        The information provided on this website,{" "}
        <a
          href="https://serenityy.ae"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://serenityy.ae
        </a>
        , is intended for general informational purposes only. While we make
        every effort to ensure that the content is accurate and up to date,
        Serenityy Marketing Management makes no guarantees regarding the
        completeness, reliability, or accuracy of any information on this site.
      </p>

      <p>
        Any reliance you place on such information is strictly at your own risk.
        Serenityy Marketing Management is not liable for any losses or damages
        in connection with the use of our website, including but not limited to
        direct, indirect, incidental, or consequential loss.
      </p>

      <p>
        This website may contain links to third-party websites or resources.
        These links are provided solely for your convenience. Serenityy
        Marketing Management does not endorse, control, or take responsibility
        for the content, policies, or practices of any third-party sites. Users
        are encouraged to review the privacy policies and terms of service of
        any external websites they visit.
      </p>

      <p>
        Nothing on this website should be construed as financial, legal, or
        investment advice. Any decision you make based on the content provided
        is your responsibility, and you are encouraged to seek professional
        advice where appropriate.
      </p>

      <p>
        We may update this disclaimer from time to time. Any changes will be
        clearly posted on this page. We recommend checking this page
        periodically for the latest version.
      </p>

      <p>
        For further questions or concerns, you may contact us at{" "}
        <a href="mailto:info@serenityy.ae">info@serenityy.ae</a>.
      </p>
    </div>
  );
};

export default Disclaimer;
